import { generateClient } from 'aws-amplify/api';
import * as mutations from '../graphql/mutations';

const client = generateClient();

export const chatCreateUserOperation = async (spaceMembershipID, userName) => {
  const response = await client.graphql({
    query: mutations.enrollUserIntoChat,
    variables: {
      spaceMembershipID,
      userName,
    },
  });
  return response.data.enrollUserIntoChat;
};

export const chatLogInUserOperation = async (spaceMembershipID) => {
  const response = await client.graphql({
    query: mutations.logInUserToChat,
    variables: {
      spaceMembershipID,
    },
  });
  return response.data.logInUserToChat;
};
